import { gql } from '@apollo/client';

export const CREATE_EDITOR_CANVAS = gql`
  mutation CreateEditorCanvas($fields: CreateEditor_canvasFieldsInput) {
    createEditor_canvas(input: { fields: $fields }) {
      editor_canvas {
        objectId
      }
    }
  }
`;

export const UPDATE_EDITOR_CANVAS = gql`
  mutation UpdateEditorCanvas(
    $id: ID!
    $fields: UpdateEditor_canvasFieldsInput
  ) {
    updateEditor_canvas(input: { id: $id, fields: $fields }) {
      editor_canvas {
        objectId
      }
    }
  }
`;

export const GET_EDITOR_CANVAS_BY_ID = gql`
  query GetEditorCanvasById($id: ID!) {
    getEditorCanvas(id: $id) {
      objectId
      status
      metadata
      defunto_pointer {
        objectId
        nome
        cognome
        soprannome
        data_morte
        data_nascita
        data_funerale
        data_trasporto
        data_chiusura_feretro
        sesso
        luogo_decesso
        nome_struttura
        luogo_morte
        indirizzo_morte
        partenza
        stato_civile_nome
        stato_civile
        residenza
        forno
        cimitero
        chiese_pointer {
          nome
          citta
          frazione
          indirizzo
        }
        allegati_pointer {
          objectId
          isRemovebg
          isBlurBg
          provino
          mimeType
          allegato {
            url
            name
          }
        }
        relation_necrofori {
          edges {
            node {
              objectId
              nome
              cognome
              cellulare
              codice_fiscale
              data_nascita
              indirizzo_residenza
              firma {
                name
                url
              }
              ruolo
              email
            }
          }
        }
      }
      editor_canvas_pages {
        edges {
          node {
            objectId
            order
            canvasJson
            animations
            soundtrackId
            gifPreviewId
            preview {
              name
              url
            }
            createdAt
            updatedAt
          }
        }
      }
      editor_project_types_pointer {
        objectId
        griglia_provino
        multiplier
        isRelatedToFuneral
        name
        order
        outputDpi
        loadReservationImages
      }
      editor_project_formats_default_pointer {
        objectId
        width
        height
        name
        unit
        generico
        dpi
        isGlobal
        minimum_border
        orientation
      }
      editor_project_formats_pointer {
        objectId
        width
        height
        orientation
        unit
        dpi
        isCustom
        name
        editor_project_formats_default_pointer {
          objectId
          width
          height
          name
          unit
          generico
          dpi
          isGlobal
          minimum_border
          orientation
        }
      }
      editor_project_types_default_pointer {
        objectId
        isGlobal
        name
        griglia_provino
        order
        outputDpi
        multiplier
        isRelatedToFuneral
        allowCustomFormats
        loadReservationImages
      }
      editor_templates_categories_default_pointer {
        objectId
        name
        order
        isGlobal
        annunciFunebri
        img {
          url
        }
        img_verticale {
          url
        }
      }
      editor_templates_categories_pointer {
        objectId
        name
        order
        isRelatedToFuneral
      }
      editor_templates_pointer {
        objectId
        name
      }
      editor_templates_default_pointer {
        objectId
        name
      }
    }
  }
`;
